module.exports = __webpack_public_path__ + "img/s-sl-img-1.c474f789.png";